export default __webpack_public_path__ + "static/media/flag-british-columbia.130acb80.svg";